export default "__VITE_ASSET__CXH4nSaO__"